import { DateProvider } from '@scenario/providers/date.provider';

export class LocaleDateProvider implements DateProvider {
  private readonly options: {
    timeZone: 'UTC';
    dateStyle: 'short';
    year: 'numeric';
    month: 'numeric';
    day: 'numeric';
  };

  constructor(private readonly language: string = 'en-GB') {}

  currentDateAsLocaleString(): string {
    return new Date().toLocaleDateString(this.language, this.options);
  }

  convertToLocaleString(date: string): string {
    return new Date(date).toLocaleDateString(this.language, this.options);
  }
}
